import { render, staticRenderFns } from "./SithMesPrdToolsPackageItemEdit.vue?vue&type=template&id=62dd0d86&"
import script from "./SithMesPrdToolsPackageItemEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdToolsPackageItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports